<template>
<section class="sub-img-section _preview-section">
    <div class="section-inner">

        <div class="sub-img-item-wrap">

            <div class="sub-img-item form_file-img md_no-image" v-for="(data, key, index) in withoutDefaultImages" v-bind:key="index">
                <img v-bind:src="data" alt="">
            </div>

        </div>

    </div>
</section>
</template>

<script>
    export default {
        props: {
            subImages: Object,
        },
        computed:{
            withoutDefaultImages(){
            const subImagesArray = Object.entries(this.subImages);
            const filteredImagesArray = subImagesArray.filter(img => {
                return img[1] !=="/img/no-image.svg";
            });
            const filteredImages = Object.fromEntries(filteredImagesArray);
            return filteredImages;
            }
        }
    }
</script>